<template>
  <div class="what-is-jujuna">
    <ShopLocations />
   
    <div class="ttl-wrapper">
      <h2 class="f-55" v-html="getTitle"></h2>
    </div>

    <div class="bold-italic f-21 editor" v-html="getTeaser"></div>

    <div class="icon" v-html="getSvg"></div>

    <div class="what-is-jujuna--footer">
      <h3 class="f-34 regular w__change">{{ $fn.tr("სად ვიყიდო") }}?</h3>
      <svg
        class="what-is-jujuna--line"
        xmlns="http://www.w3.org/2000/svg"
        width="920"
        height="1"
        viewBox="0 0 920 1"
      >
        <line
          id="Line_128"
          data-name="Line 128"
          x2="920"
          transform="translate(0 0.5)"
          fill="none"
          stroke="#3a5aa7"
          stroke-width="1"
          opacity="0.3"
        />
      </svg>

      <div class="what-is-jujuna--footer--row">
        <div
          class="what-is-jujuna--footer--row--child"
          @click="openShopLocations"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="24"
            viewBox="0 0 22 24"
          >
            <g id="shop" transform="translate(-1 0)">
              <path
                id="Path_4299"
                data-name="Path 4299"
                d="M16,13a5,5,0,0,1-8,0,4.956,4.956,0,0,1-7,.977V19a5.006,5.006,0,0,0,5,5H18a5.006,5.006,0,0,0,5-5V13.974A4.956,4.956,0,0,1,16,13Z"
                fill="#044b30"
              />
              <path
                id="Path_4300"
                data-name="Path 4300"
                d="M21.7,3.131A3.975,3.975,0,0,0,17.792,0H17V3a1,1,0,0,1-2,0V0H9V3A1,1,0,0,1,7,3V0H6.208A3.975,3.975,0,0,0,2.3,3.132L1.022,8.9,1,10.02A3,3,0,1,0,7,10a1,1,0,0,1,2,0,3,3,0,0,0,6,0,1,1,0,0,1,2,0,3,3,0,0,0,6,0V9.107Z"
                fill="#044b30"
              />
            </g>
          </svg>
          <span class="f-21 bold-italic underline pointer w__change">{{
            $fn.tr("მაღაზიები")
          }}</span>
        </div>

        <div class="what-is-jujuna--footer--row--child">
           <OrderService :top_cont="true" />
        </div>

        <div class="what-is-jujuna--footer--row--child" @click="openBarMap();">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <g id="cocktails" transform="translate(0 -0.001)">
              <g
                id="Group_3547"
                data-name="Group 3547"
                transform="translate(0 0.001)"
              >
                <path
                  id="Path_4301"
                  data-name="Path 4301"
                  d="M18.546,0A5.464,5.464,0,0,0,13.2,4.365H1.091A1.091,1.091,0,0,0,.32,6.227l8.408,8.4v7.189H5.452a1.091,1.091,0,0,0,0,2.182h8.732a1.091,1.091,0,1,0,0-2.182H10.909V14.63l4.626-4.624a5.455,5.455,0,1,0,3.01-10Zm0,8.727a3.261,3.261,0,0,1-1.412-.319l2.183-2.182a1.091,1.091,0,0,0-.771-1.862H15.46a3.273,3.273,0,1,1,3.085,4.364Z"
                  transform="translate(0 -0.001)"
                  fill="#044b30"
                />
              </g>
            </g>
          </svg>

          <span class="f-21 bold-italic underline pointer w__change">{{
            $fn.tr("ბარები")
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShopLocations  from "@/components/ShopLocations";
import OrderService from "@/components/OrderService";

export default {
  props: ["contentData"],
  components: {
    ShopLocations,
    OrderService,
  },
  data() {
    return {};
  },
  methods: {
    openShopLocations() {
      this.$store.commit(
        "main/shopLocationsStatus",
        !this.$store.state.main.shopLocationActive
      );
    },

          openBarMap() {
          this.$store.commit("main/barMapStatus", !this.$store.state.main.barMapActive);
    }
  },
  computed: {
    getTitle() {
      return _.get(this.contentData, "data.list.0.title");
    },
    getTeaser() {
      return _.get(this.contentData, "data.list.0.teaser");
    },
    getSvg() {
      return _.get(this.contentData, "data.list.0.svg");
    }
  }
};
</script>

<style lang="scss">
.what-is-jujuna .editor {
  margin-top: 55px;
}
.what-is-jujuna .editor p, .what-is-jujuna .editor  span,  .what-is-jujuna .editor  strong,  .what-is-jujuna .editor  h1,  .what-is-jujuna .editor  h2,  .what-is-jujuna .editor  h3,  .what-is-jujuna .editor  h4,  .what-is-jujuna .editor  h5,  .what-is-jujuna .editor  h6,  .what-is-jujuna .editor  em {
  font-family: "FiraGO-BoldItalic";
  margin: 0;
  padding-bottom: 0;
  will-change: transform;
}

.what-is-jujuna h2 {
  will-change: transform;
}

.what-is-jujuna {
  &--line {
    width: 100%;
  }
  &--footer {
    position: relative;
    display: flex;
    flex-direction: column;
    margin-top: 144px;
    // width: 100%;

    
    h3 {
      color: #ff6414;
      text-align: center;
      margin-bottom: 34px;
    }

    &--row {
      display: flex;
      justify-content: space-between;
      margin-top: 21px;
      width: 100%;
      max-width: 920px;

      &--child {
        display: flex;
        align-items: center;
    &:not(:last-child){
      margin-right: 20px;

    }
    @media (max-width: 767px){
      &:not(:last-child){
      margin-right: 0px;

    }
    }
        span {
          color: #044b30;
          margin-left: 13px;
        }
      }
      @media (max-width: 767px) {
        flex-direction: column;
        justify-content: initial;
        align-items: center;
    
        &--child {
          margin-bottom: 35px;
        }
      }

      @media (max-width: 413px) {
        &--child {
          span {
            font-size: 16px;
          }
        }
      }
    }



    @media (max-width: 767px){
      margin-top: 80px;
    }
     @media (max-width: 413px){
      margin-top: 55px;
    }
  }
}
</style>
